import { Fee } from '@fluentsms/graphql';
import React, { createContext, ReactNode, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { StatementPayeeDisplayNameProps, useStatementPayeeDisplayName } from './useStatementPayeeDisplayName';

const StatementPayeeDisplayNameContext = createContext<StatementPayeeDisplayNameProps>({
  formFieldValue: '',
  inputTextFocused: false,
  shouldShowMenuOption: false,
  shouldShowTextInput: false,
  setFormFieldValue: () => undefined,
  setInputTextFocused: () => undefined,
  setShouldShowTextInput: () => undefined,
});

export const useStatementPayeeDisplayNameContext = () => useContext(StatementPayeeDisplayNameContext);

export const StatementPayeeDisplayNameProvider = ({
  children,
  formMethods,
}: {
  children: ReactNode;
  formMethods: UseFormReturn<Fee, object>;
}) => {
  const value = useStatementPayeeDisplayName(formMethods);

  return (
    <StatementPayeeDisplayNameContext.Provider value={value}>{children}</StatementPayeeDisplayNameContext.Provider>
  );
};
